<template>
  <div class="header-wrap">
    <div class="container">
      <div class="header">
        <div class="logo-wrap">
          <span class="logo" @click="$router.push({path:'/', name: 'landing'})">fotty</span>
        </div>
        <div class="menu-wrap">
          <router-link to="/profile/" class="button-group">
            <div>
              <span class="icon-wrap">
                <SvgIcon fill="#fff" name="user_ico" width="27px" height="27px"></SvgIcon>
              </span>
              <span class="title">Профиль</span>
            </div>
          </router-link>
          <router-link to="/events/" class="button-group" v-if="user.is_completed">
            <div>
              <span class="icon-wrap">
                <SvgIcon fill="#fff" name="events_ico" width="27px" height="27px"></SvgIcon>
              </span>
              <span class="title">События</span>
            </div>
          </router-link>
          <router-link to="/payments/" class="button-group">
            <div>
              <span class="icon-wrap">
                <SvgIcon fill="#fff" name="tarif_ico" width="24px" height="24px"></SvgIcon>
              </span>
              <span class="title">{{balance_masked ? balance_masked +' ₽': 'Баланс'}}</span>
            </div>
          </router-link>
        </div>
        <div class="support-wrap">
          <div class="button-group logout">
            <div class="logout-btn" @click="logout">
              <span class="icon-wrap">
                <SvgIcon name="exit" width="23px" height="23px"></SvgIcon>
              </span>
              <span class="title">Выход</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SvgIcon from "@/components/basic/SvgIcon.vue";
import { mapGetters,mapActions } from "vuex";
import { tokenMethods } from "@/library/lib";

export default {
  name: "Header",
  components: {
    SvgIcon
  },
  data() {
    return {
      currentRoute: this.$router.currentRoute.name
    };
  },
  watch: {
    $route(to) {
      this.currentRoute = to.name;
    }
  },
  mounted(){
    this.loadBalance()
  },
  methods: {
    logout: function() {
      this.$store.dispatch("user/logout").then(() => {
        tokenMethods.removeToken();
        this.$store.commit("user/CLEAR_USER_INFO");

        this.$router.push({ path: "/" });
      });
    },
    ...mapActions({
      loadBalance:"payment/load_balance"
    })
  },
  computed: {
    ...mapGetters({
      user: "user/get_user",
      events: "events/get_events",
      balance_masked:'payment/balance_masked'
    })
  }
};
</script>

<style lang="scss" scoped>
.header-wrap {
  width: 100%;
  height: 56px;
  background-color: $mainColor;
  color: #fff;
  .container {
    height: 100%;
  }
  .header {
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
    height: 100%;

    .logo-wrap {
      display: flex;
      align-items: center;
      .logo {
        cursor: pointer;
        font-weight: 900;
        font-size: 32px;
        line-height: 40px;
      }
    }
    .menu-wrap,
    .support-wrap {
      .logout-btn {
        cursor: pointer;
      }
      display: flex;
      align-items: center;
    }
    .support-wrap {
      justify-content: flex-end;
    }
    .button-group {
      @extend %bRadius;
      padding: 6px 12px;
      &.logout{
         padding: 6px 0 6px 12px;
      }
      //   color: #fff;
      //   a{
      //       color: #fff;
      //   }
      &:not(:last-child) {
        margin-right: 16px;
      }
      .icon-wrap {
        padding: 3.5px;
        margin-right: 8px;
      }
      &.active,
      &.router-link-active {
        background: rgba(255, 255, 255, 0.1);
        border: 1px solid rgba(255, 255, 255, 0.2);
      }
    }
  }
}
</style>
